export default {"src":"/_next/static/media/content_image_single_1.c1672105.svg","height":500,"width":500,"blurWidth":0,"blurHeight":0};